module.exports = __webpack_public_path__ + "static/media/h1.d8872164.svg";